import React from 'react';
import { Button, DialogActions, DialogTitle } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';
import { Auth } from 'aws-amplify';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import { useRecoilValue } from 'recoil';

import {
    reconnectSubscriptionTicket,
    unsubscribeAllEventTicket
} from '@/component/common/TicketSubscriptionHandler';
import { corporationAtom } from '@/state/atom/corporationAtom';


export const TicketReconnectDialog = (props) => {

    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);

    //btn close
    const onClickBtnClose = (event, reason) => {
        document.querySelector(".close-reconnect-subscription-button").click();
        
        if (event && reason === "backdropClick") {
            return false;
        }
        // close all connect socket
        unsubscribeAllEventTicket();

        // close reconnect dialog
        props.setIsShowReconnectDialog(false);

        Auth.signOut()
            .then((data) => {
                let infoCorporation = localStorageUtil.getContractTypeAndSubDomainCorp();
                infoCorporation = Utils.convertJSONDataToObject(infoCorporation);
                let urlAfterLogout = Utils.getUrlLinkCorporation(infoCorporation.contractType, infoCorporation.subDomainInvite);
                
                props.history.push(urlAfterLogout);
                localStorageUtil.deleteCorporationDomain();
                localStorageUtil.deleteTicketListType();
                localStorageUtil.deleteLisProjectOfUser();
                localStorageUtil.deleteSelectedProjectId();
                localStorageUtil.deleteSelectedProjectType();
                localStorageUtil.deleteUserDetailId();
                localStorageUtil.deleteAffiliationOrganization();

                sessionStorage.clear();
                // clear Interval
                clearInterval(window.intervalCheckAuthen);
            }).catch(err => console.log(err));
        // props.history.push(Constant.LIST_TICKET_ROUTER);
    };

    // btn reconnect
    const onClickBtnReconnect = () => {
        // init subscription handler
        let argsCommon = {
            ...props,

            corporationDetail: corporationDetail,

            updatedTicket: props.updatedTicket,
            setUpdatedTicket: props.setUpdatedTicket,

            ticketList: props.ticketList,
            setTicketList: props.setTicketList,

            isLoading: props.isLoading,
            setIsLoading: props.setIsLoading,

            isShowReconnectDialog: props.isShowReconnectDialog,
            setIsShowReconnectDialog: props.setIsShowReconnectDialog
        };

        // reconnect socket
        reconnectSubscriptionTicket(argsCommon);
        
        // close reconnect dialog
        props.setIsShowReconnectDialog(false);

        document.querySelector(".reconnect-subscription-button").click();
    };

    return (
        <Dialog
            open={props.isShowReconnectDialog}
            onClose={(event, reason) => onClickBtnClose(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        // disableBackdropClick="true" 
        >
            <DialogTitle className="titleHeader">
                <h2 className="title">{I18n.get('COMLB001')}</h2>
            </DialogTitle>
            <DialogContent>
                <div className="confirm-dialog-content">
                    {I18n.get('COMMSG002')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action close-reconnect-subscription-button">
                {/* btn close */}
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={onClickBtnClose}>
                    {I18n.get('COMBTN006')}
                </Button>
                {/* btn reconnect */}
                <Button
                    className="confirm-dialog-button reconnect-subscription-button"
                    variant="contained"
                    color="primary"
                    onClick={onClickBtnReconnect}>
                    {I18n.get('COMBTN005')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

